import React from "react";
import LazyGoogleButton from "./LazyGoogleButton";

/**
 * Google Sign-In wrapper with lazy loading to prevent blocking during network issues
 */
function SignInWithGoogle({ googleResponse }) {
  return <LazyGoogleButton googleResponse={googleResponse} />;
}

export default SignInWithGoogle;
